import { type ObjectValuesUnionType } from '../../utils/typing';

export const CashoutActionTypes = Object.freeze({
  CASHOUT_TOTAL: 'cashout/total',
  CASHOUT_PARTIAL: 'cashout/partial',
  CASHOUT_ENHANCE: 'cashout/enhance',
  CASHOUT_REQUEST: 'cashout/request',
  CASHOUT_FAIL: 'cashout/fail',
  CASHOUT_SUCCESS: 'cashout/success',
});

export type CashoutActionType = ObjectValuesUnionType<typeof CashoutActionTypes>;
